<template>
  <div id="cart" class="full_layout cart" v-loading.fullscreen="loading">
    <div v-if="list">
      <div class="cartTitle" v-if="addressList!=null&&list!=null">
        
        <template v-if="userInfo.NationCode!='+86'||userInfo.MemberSource!='CN'">
          <el-alert :title="$t('alertCustoms')" type="warning" :closable="false" show-icon style="margin-bottom: 30px;"></el-alert>
        </template>
        <h3>{{$t('SelectAddress')}}<span>({{$tc('CountItem',list.Details.length,{ n: list.Details.length })}})</span></h3>
      </div>
      <div v-if="addressList!=null">
        <to-address :title='title' :domVisible='dislogType.address' :list='addressItem' :isSet="isSet" @closeDialog="closeDialog" v-if="dislogType.address" />
        <div class="addressShow" :class="isAddShow?'on':''">
          <ul class="addressList">
            <!-- [item._id==list.AddressId?'on':isAdd==index?'on':''] -->
            <li v-for="(item,index) in addressList" :key='index' :class="isAdd==index?'on':''" @click="setOnlyAddress(index,item)">
              <div>
                <div class="addressName">{{item.City}} ({{item.UserName}}{{$i18n.locale==='zh'?"收":""}})</div>
                <div class="addressText line_txt2">{{item.Provice|setProvice}} {{item.AddressDetail}} {{item.ZipCode}}</div>
                <div class="addressPhone">{{item.Email}}</div>
                <div class="addressPhone">{{item.Mobile}}</div>
              </div>
              <span class="default" v-if="item.IsDefault">{{$t('Default')}}</span>
              <span class="setAddress" @click="setAddress('address',1,item)">{{$t('Edit')}}</span>
            </li>
          </ul>
        </div>
        <div class="setInfoBox space_between" :class="{'addressShow':(addressCount<=0)}">
          <div class='isShow' @click="IsShow" v-if="addressCount>4">{{isAddShow?$t('Hide'):$t('ViewAllAddresses')}}</div>
          <div class='isShow' v-else></div>
          <div class="setinfo" @click="setAddress('address',0)">{{$t('AddNewAddress')}}</div>
        </div>
      </div>
      <div class='stageDetail' v-if="list.Details[0].Presale==1||list.OrderPresale==1">
        <div class="stageOne" :class="(list.Details[0].Presale==1&&!ischeck)||(ischeck&&!list.IsPayDeposit)?'on':''">
          <div class="">
            <div class="stageRadius"></div>
            <div>{{$t('Stage1')}}</div>
            <div v-if="!ischeck">{{$t('PayDeposit')}} <span class="price">￥ {{priceCount(list.Details[0].AdvancePrice,list.Details[0].Num,'multi').toLocaleString()}}</span></div>

            <div v-if="ischeck">{{$t('PayDeposit')}} <span class="price">￥ {{list.AdvancePrice.toLocaleString()}}</span></div>
          </div>
          <span class="span"><i></i></span>
        </div>
        <div class="stageTwo" :class="{'on':(list.IsPayDeposit&&ischeck)}">
          <div class="">
            <div class="stageRadius"></div>
            <div>{{$t('Stage2')}}</div>
            <div v-if="!ischeck">{{$t('PayBalance')}} <span class="price">￥ {{priceCount(priceCount(list.Details[0].LowestPrice,list.Details[0].AdvancePrice,'sub'),list.Details[0].Num,'multi').toLocaleString()}}</span></div>
            <div v-if="ischeck">{{$t('PayBalance')}} <span class="price">￥ {{priceCount(list.RealOrderPrice,list.AdvancePrice,'sub').toLocaleString()}}</span></div>
          </div>
          <span class="span"><i></i></span>
        </div>
      </div>
      <div class="cart_list_title check_list cart_list">
        <div class="cart_list_products">{{$t('Product')}}</div>
        <div class="cart_list_detail"></div>
        <div class="cart_list_price">{{$t('UnitPrice')}}</div>
        <div class="cart_list_number">{{$t('Quantity')}}</div>
        <div class="cart_list_total">{{$t('Total')}}</div>
      </div>
      <template v-if="list!=null">
        <div class="check_list cart_list" v-for="(item,index) in list.Details" :key="index" >
          <div class="cart_list_products">
            <router-link class="cart_img" :to="{path:'/market/item/'+item._id+'?type=1'}">
              <img :src="item.TitImg+'?imageView2/2/w/160'">
              <span class="icon_presale" v-if="item.Presale==1||(list.OrderPresale==1)">{{$t('PreSale')}}</span>
            </router-link>
          </div>
          <div class="cart_list_detail space_between">
            <router-link :to="{path:'/market/item/'+item._id+'?type=1'}">
              <p>{{item.Title}}</p>
            </router-link>
          </div>
          <!-- 非积分 -->
          <div class="cart_list_price" v-if="!item.IsPoints||item.IsPoints<1">
            <del v-if="item.Price!=item.LowestPrice">￥ {{item.Price.toLocaleString()}}</del>
            <span v-if="item.Price==item.LowestPrice">￥ {{item.Price.toLocaleString()}}</span>
            <span v-if="item.Price!=item.LowestPrice" class="price_red">￥ {{item.LowestPrice.toLocaleString()}}</span>
          </div>
          <!-- 积分 -->
          <div class="cart_list_price" v-if="item.IsPoints==1">
            <div class="cart_point_price" v-if="!ischeck">
              <span>{{item.PointsScore}} {{$t('Points')}}</span>
              <span v-if="item.Price>0">+￥ {{item.Price.toLocaleString()}}</span>
            </div>
            <div class="cart_point_price" v-if="ischeck">
              <span>{{item.PointsScore}} {{$t('Points')}}</span>
              <span v-if="item.Price>0">+￥ {{item.Price.toLocaleString()}}</span>
            </div>
          </div>
          <div class="cart_list_number">
            <span>{{item.Num}}</span>
          </div>

          <!-- 非积分 -->
          <div class="cart_list_total" v-if="(!item.IsPoints||(item.IsPoints<1&&!ischeck))||(list.OrderPresale!=2&&ischeck)">
            <span v-if="((list.Details[0].Presale==0||list.Details[0].Presale==null)&&!ischeck)||(list.OrderPresale!=1&&ischeck)">￥ {{priceCount(item.LowestPrice,item.Num,'multi').toLocaleString()}}</span>
            <div v-if="(item.Presale==1&&!ischeck)||(ischeck&&!list.IsPayDeposit&&list.OrderPresale==1)" class="itemPresale" :class="`lang-${$i18n.locale}`">
              <span class="">￥ {{ischeck?list.AdvancePrice.toLocaleString():priceCount(list.Details[0].AdvancePrice,list.Details[0].Num,'multi').toLocaleString()}}</span>
              <span class="" v-if="!ischeck">( {{$t('Balance')}} ￥ {{priceCount(priceCount(list.Details[0].LowestPrice,list.Details[0].AdvancePrice,'sub'),list.Details[0].Num,'multi').toLocaleString()}} )</span>
              <span v-if="ischeck">( {{$t('Balance')}} ￥ {{priceCount(list.RealOrderPrice,list.AdvancePrice,'sub').toLocaleString()}} )</span>
            </div>
            <div v-if="list.IsPayDeposit&&ischeck" class="itemPresale PayDeposit" :class="`lang-${$i18n.locale}`">
              <span class="">￥ {{list.RealOrderPrice.toLocaleString()}}</span>
              <span class="">( {{$t('Deposit')}} ￥ {{list.AdvancePrice.toLocaleString()}} )</span>
            </div>
          </div>
          <!-- 积分 -->
          <div class="cart_list_total" v-if="(item.IsPoints==1&&!ischeck)||(list.OrderPresale==2&&ischeck)">
            <div class="cart_point_price" v-if="!ischeck">
              <div>{{priceCount(item.PointsScore,list.Details[0].Num,'multi')}} {{$t('Points')}}</div>
              <div v-if="item.Price>0">+￥ {{priceCount(item.Price,list.Details[0].Num,'multi').toLocaleString()}}</div>
            </div>
            <div class="cart_point_price" v-if="ischeck">
              <div>{{item.TotalPoints}} {{$t('Points')}}</div>
              <div v-if="item.TotalPrice>0">+￥ {{item.TotalPrice.toLocaleString()}}</div>
            </div>
          </div>
        </div>
      </template>
      <div class="subTotalBox" v-if="list!=null">
        <div class="subTotal" v-if="((list.Details[0].Presale==0||list.Details[0].Presale==null)&&list.Details[0].IsPoints!=1&&!ischeck)||(list.OrderPresale!=1&&ischeck&&list.OrderPresale!=2)">
          <div class="space_between">
            <span>{{$t('Total')}}</span>
            <span class="price">{{countOrder(list.Details,0)}}</span>
          </div>
          <div class="space_between">
            <span>{{$t('Quantity')}}</span>
            <span class="">{{countOrder(list.Details,3)}}</span>
          </div>
          <div class="space_between" v-if="countOrder(list.Details,2)>0">
            <span>{{$t('Discount')}}</span>
            <span class='price price_red'>- {{countOrder(list.Details,2)}}</span>
            <!-- <span class='price price_red' v-if="ischeck">{{priceCount(countOrder(list.Details,2),(list.DiscountPrice!=null?list.DiscountPrice:0),'add')}}</span> -->
          </div>
          <div class="space_between" v-if="ischeck&&list.DiscountPrice>0">
            <span>{{$t('StaffDiscount')}}</span>
            <span class='price price_red'>- {{list.DiscountPrice.toLocaleString()}}</span>
          </div>
          <div class="space_between total">
            <span>{{$t('Subtotal')}}</span>
            <span class='price'>{{ischeck?list.OrderPrice.toLocaleString():countOrder(list.Details,1)}}</span>
          </div>
          <el-button class='subtn' :disabled="addressList!=null?disabled:true" type="primary" @click="createOrder">{{!ischeck?'Submit order':'Pay now'}}</el-button>
        </div>
        <div class="subTotal" v-if="(list.Details[0].Presale==1&&list.Details[0].IsPoints!=1)||(list.OrderPresale==1)">
          <div class="space_between total" v-if='(list.Details[0].Presale==1&&!ischeck)||(ischeck&&!list.IsPayDeposit)'>
            <span>{{$t('PayDeposit')}}</span>
            <span class='price' v-if="!ischeck">{{priceCount(list.Details[0].AdvancePrice,list.Details[0].Num,'multi').toLocaleString()}}</span>
            <span class='price' v-if="ischeck">{{list.AdvancePrice.toLocaleString()}}</span>
          </div>
          <div class="space_between" v-if='ischeck&&list.IsPayDeposit'>
            <span>{{$t('Total')}}</span>
            <span class="price">{{countOrder(list.Details,0)}}</span>
          </div>
          <div class="space_between" v-if='ischeck&&list.IsPayDeposit'>
            <span>{{$t('Quantity')}}</span>
            <span class="">{{countOrder(list.Details,3)}}</span>
          </div>
          <div class="space_between" v-if="ischeck&&list.IsPayDeposit">
            <span>{{$t('Discount')}}</span>
            <span class='price price_red'>- {{countOrder(list.Details,2)}}</span>
          </div>
          <div class="space_between" v-if="ischeck&&list.DiscountPrice>0">
            <span>{{$t('StaffDiscount')}}</span>
            <span class='price price_red'>- {{list.DiscountPrice.toLocaleString()}}</span>
          </div>
          <div class="space_between" v-if='ischeck&&list.IsPayDeposit'>
            <span>{{$t('Deposit')}}</span>
            <span class='price price_red'>- {{list.AdvancePrice.toLocaleString()}}</span>
          </div>
          <div class="space_between total" v-if='ischeck&&list.IsPayDeposit'>
            <span>{{$t('Subtotal')}}</span>
            <!-- <span class='price'>{{priceCount(list.RealOrderPrice,(priceCount(list.AdvancePrice,list.Details[0].Num,'multi')),'sub').toLocaleString()}}</span> -->
            <span class='price'>{{priceCount(list.RealOrderPrice,list.AdvancePrice,'sub').toLocaleString()}}</span>
          </div>
          <el-button class='subtn' :disabled="disabled" type="primary" @click="createOrder">
            {{((list.Details[0].Presale==1&&!ischeck)||(ischeck&&!list.IsPayDeposit))?$t('PayDeposit'):$t('PayBalance')}}
          </el-button>
          <div class="space_between orderPresale">
            <span class="textPresale">{{$t('verify.FinalPayment')}}</span>
          </div>
        </div>
        <!-- 积分 -->
        <!-- 商品详情 -->
        <div class="subTotal" v-if="list.Details[0].IsPoints==1&&!ischeck">
          <div class="space_between">
            <span>{{$t('Points')}}</span>
            <span class="">{{priceCount(list.Details[0].PointsScore,list.Details[0].Num,'multi')}} {{$t('Points')}}</span>
          </div>
          <div class="space_between" v-if="(list.Details[0].Price>0&&!ischeck)">
            <span>{{$t('UnitPrice')}}</span>
            <span class="">{{priceCount(list.Details[0].Price,list.Details[0].Num,'multi').toLocaleString()}}</span>
          </div>
          <div class="space_between" >
            <span>{{$t('Shipping')}}</span>
            <span class="">{{$t('PayonDelivery')}}</span>
          </div>
          <div class="space_between total">
            <span>{{$t('Subtotal')}}</span>
            <span class='total_point'>{{priceCount(list.Details[0].PointsScore,list.Details[0].Num,'multi')}} {{$t('Points')}} <i v-if="(list.Details[0].Price>0&&!ischeck)">+ ￥ {{priceCount(list.Details[0].Price,list.Details[0].Num,'multi').toLocaleString()}}</i></span>
          </div>
          <el-button class='subtn' :disabled="disabled" type="primary" @click="createOrder">{{!ischeck?$t('Submit'):$t('Pay')}}</el-button>
        </div>
        <!-- 订单详情 -->
        <div class="subTotal" v-if="list.OrderPresale==2&&ischeck">
          <div class="space_between">
            <span>{{$t('Points')}}</span>
            <span class="">{{list.RealPoints}} {{$t('Points')}}</span>
          </div>
          <div class="space_between" v-if="(list.RealOrderPrice>0)">
            <span>{{$t('UnitPrice')}}</span>
            <span class="">{{list.RealOrderPrice.toLocaleString()}}</span>
          </div>
          <div class="space_between" >
            <span>{{$t('Shipping')}}</span>
            <span class="">{{$t('PayonDelivery')}}</span>
          </div>
          <div class="space_between total">
            <span>{{$t('Subtotal')}}</span>
            <span class='total_point'>{{list.RealPoints}} {{$t('Points')}} <i v-if="(list.RealOrderPrice>0)">+ ￥ {{list.RealOrderPrice.toLocaleString()}}</i></span>
          </div>
          <el-button class='subtn' :disabled="disabled" type="primary" @click="createOrder">{{!ischeck?$t('Submit'):$t('Pay')}}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getInfo, numAdd, numSub, numMulti,Tip } from "@/api/public";
import ToAddress from '@/components/dialog/address'
export default {
  name: 'cart',
  components: { ToAddress },
  data() {
    return {
      userInfo: getInfo(),
      loading: false,
      disabled: false,
      isAddShow: false,
      isaddlist: false,
      title: "",
      isAdd: 0,
      addressItem: null,
      isSet: false,
      dislogType: this.$enumInfo.dislogType,
      pi: this.$enumInfo.addressPage.pageindex,
      ps: this.$enumInfo.addressPage.pagesize,
      addressList: null,
      addressCount: 0,
      list: null,
      ischeck: this.$route.params.id ? true : false
    }
  },
  filters: {
    setProvice(val){
      // var regex = /(<([^>]+)>)/ig;
      if(val!=null){
        // val=val.replace(regex,'');
        val=val.replace(/\-/g,' ');
        //val=val.replace('&nbsp;','');
      }
      return val
    }
  },
  mounted() {
  },
  created() {
    //console.log(this.ischeck)
    if (this.ischeck) {
      this.getOrderDetail(this.$route.params.id)
    }else{
      this.list = window.sessionStorage.getItem('dakacheck');
      this.list = JSON.parse(this.list);
      this.getAddress()
    }
  },
  methods: {
    //计算价格
    priceCount(num1,num2,type){
      let num=0;
      if(type=='add'){
          num = numAdd(num1, num2)
      }
      if(type=='sub'){
          num = numSub(num1, num2)
      }
      if(type=='multi'){
          num = numMulti(num1, num2)
      }
      return num.toLocaleString()
    },
    /**
 * 获取订单详细信息
 * @param {string|number} val - 订单ID
 * @param {number} type - 操作类型，1表示支付订单判断，其他类型仅获取订单详情
 * @description 根据订单ID获取订单完整信息，包括订单详情、价格、地址等数据。
 * 当type为1时，会根据订单状态、订单类型（普通/预售/积分）和支付类型进行路由跳转判断：
 * - 非预售订单：状态为1跳转至支付页，否则跳转至订单详情页
 * - 预售订单：状态为1且支付类型为2且支付检查为1或3时跳转至订单详情页，否则跳转至支付页
 */
    getOrderDetail(val, type) {
      let that = this;
      that.loading = true;
      let data = { Id: val }
      that.$get(that.$interface.GetOrderById, data).then(res => {
        if (res.Result != 0) {
          var obj=res.Data
          obj.Details=obj.OrderDetails
          obj.OrderPrice=obj.RealOrderPrice
          obj.AddressId=obj.AddressId
          that.list=obj
          that.getAddress()
        } else {
          that.$message.error(res.Msg);
        }
        that.loading = false
      })
    },
    createOrder() {
      let that = this;
      const addressDetail = that.addressList[that.isAdd];
      if(addressDetail.Email){
        that.loading = true;
        that.disabled = true;
        if (!that.ischeck) {
          //let addressDetail = that.addressList[that.isAdd];
          let commoditys = [];
          that.list.Details.map(item => {
            commoditys.push({ commodityId: item.CommodityId, num: item.Num })
          })
          let isCrat = that.list.isCrat || 0
          let data = {
            memberId: that.userInfo._id,
            nickName: that.userInfo.NickName,
            addressId: addressDetail._id,
            userName: addressDetail.UserName,
            mobile: addressDetail.Mobile,
            provice: addressDetail.Provice,
            email: addressDetail.Email,
            city: addressDetail.City,
            addressDetail: addressDetail.AddressDetail,
            country: addressDetail.Country,
            zipCode: addressDetail.ZipCode,
            isCart: isCrat,
            commoditys: commoditys
          }
          that.$post(that.$interface.CreateOrder, data).then(res => {

            if (res.Result != 0) {
              if(res.Data.Status==2){
                that.$router.push({ path: '/user/order?type=2'})
              }else{
                that.$router.push({ path: '/pay/' + res.Data.OrderId })
              }
              //
            } else {
              that.$message.error(res.Msg);
            }
            that.loading = false;
            that.disabled = false;
          })
        } else {
            that.disabled = true;
            that.goToPay()
          //that.getOrderDetail(this.$route.params.id,1)
          //this.$route.params.id
        }
      }else{
        Tip('warning',that.$t('alertEmail'))
      }
    },
    goToPay(){
      const that = this;
      const data=that.list
      if(data.OrderPresale!=1){
        // 非预售订单
        if(data.Status!=1){
          that.$router.push({ path: '/order/detail/' + that.$route.params.id })
        }else{
          that.$router.push({ path: '/pay/' + that.$route.params.id })
        }
      }else{
        // 预售订单
        if(data.Status!=1){
          that.$router.push({ path: '/order/detail/' + that.$route.params.id })
        }else{
          if(data.PayType==2&&(data.PayCheck==1||data.PayCheck==3)){
            that.$router.push({ path: '/order/detail/' + that.$route.params.id })
          }else{
          that.$router.push({ path: '/pay/' + that.$route.params.id })
          }
        }
      }
      that.disabled = false;
      that.loading = false;
    },
    getAddress() {
      let that = this;
      that.loading = true;
      let data = { MemberId: that.userInfo._id, PageIndex: that.pi, PageSize: that.ps }
      that.$get(that.$interface.SearchShippingAddresses, data).then(res => {
        if (res.Result != 0) {
          that.addressList = res.Data;
          that.addressCount = res.Count;
          if(res.Count<0){
            that.disabled = true;
          }
          if (that.ischeck) {
            res.Data.map((it, i) => {
              if (it._id == that.list.AddressId) {
                that.isAdd = i
              }
            })
          }
        }
        that.loading = false;
      })
    },
    IsShow() {
      this.isAddShow = !this.isAddShow
    },
    setAddress(val, type, obj) {
      if (type == 1) {
        this.title = this.$t('UpdateAddress')
        this.addressItem = JSON.parse(JSON.stringify(obj))
      } else {
        this.title = this.$t('AddNewAddress')
      }
      this.isSet = type > 0 ? false : true;
      this.dislogType[val] = true;
    },
    closeDialog(val, bol) {
      this.dislogType[val] = bol
      this.getAddress()
    },
    setOnlyAddress(val,item) {
      let that = this;
      if(that.addressList[that.isAdd]._id===item._id) {
        return;
      }
      if(item.Email){
        that.isAdd = val;
        if (that.ischeck) {
          that.upDataOrder()
        }
      } else {
        Tip('warning',that.$t('alertEmail'))
      }
    },
    upDataOrder() {
      let that = this;
      that.loading = true;
      that.disabled = true;
      let newaddInfo = that.addressList[this.isAdd]
      let data = {
        id: this.$route.params.id,
        addressId: newaddInfo._id,
        userName: newaddInfo.UserName,
        mobile: newaddInfo.Mobile,
        provice: newaddInfo.Provice,
        email: newaddInfo.Email,
        city: newaddInfo.City,
        addressDetail: newaddInfo.AddressDetail,
        zipCode: newaddInfo.ZipCode,
        country: newaddInfo.Country,
      }
      that.$post(that.$interface.ModifyOrderAdress, data).then(res => {
        if (res.Result != 0) {

          that.getOrderDetail(that.$route.params.id)
          //that.$emit('closeDialog', 'setOrderAddress', false, 1)
        } else {
          that.$message.error(res.Msg);
        }
        that.disabled = false;
        that.loading = false;
      })
    },
    // 计算购物车价格  type 0:总价，1:共计，2:优惠
    countOrder(obj, type) {
      let inall = 0
      let reduction = 0
      let total = 0
      let num = 0
      if (obj.length > 0) {
        //this.disabled = false;
        obj.map(res => {
          inall += numMulti(res.Price, res.Num)
          total += numMulti(res.LowestPrice, res.Num)
          num = numAdd(num, res.Num)
        })
        if (type == 0) {
          return inall.toLocaleString()
        }
        if (type == 1) {
          return total.toLocaleString()
        }
        if (type == 2) {
          return numSub(inall, total).toLocaleString()
        }
        if (type == 3) {
          return num
        } else {
          return 0
        }
      } else {
       // this.disabled = true;
        return 0
      }
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/pay.css";

</style>



// WEBPACK FOOTER //
// src/pages/pay/checkout.vue